module.exports = __webpack_public_path__ + "static/media/Primary_Discover.c13de2c7.svg";